import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import React, { FC } from "react";

type PasswordFieldProps = {
  label: string;
  name: string;
  value: string;
  error: boolean;
  helperText: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPassword: boolean;
  onTogglePasswordVisibility: () => void;
} & TextFieldProps;

const PasswordField: FC<PasswordFieldProps> = ({
  label,
  name,
  value,
  error,
  helperText,
  onChange,
  showPassword,
  onTogglePasswordVisibility,
  ...rest
}) => {
  return (
    <TextField
      label={label}
      type={showPassword ? "text" : "password"}
      variant="outlined"
      required
      fullWidth
      name={name}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={onTogglePasswordVisibility} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default PasswordField;
